import React, {useContext} from 'react'
import { Typography, FormControlLabel, Radio } from '@mui/material'
import { ComplaintState } from '../../../contexts/types'
import {OrgCustomizationContext} from "../../../themes/OrgCustomizationProvider";
import {Trans} from "react-i18next";

type IFUOptionsProps = {
    complaint: ComplaintState
}

const IFUOptions: React.FC<IFUOptionsProps> = ({ complaint }) => {
    const eventOccurrence = complaint.complaintType.location
    const { t, tns } = useContext(OrgCustomizationContext)

    return (
        <>
            {/* IFU */}
            <Typography
                variant='body1'
                color='secondary.contrastText'
                sx={{ pt: 2 }}
            >
                <Trans i18nKey={tns('cti_complaint_ifu')}>
                    -
                    <Typography component='span' sx={{ color: 'primary.main' }}>
                        -
                    </Typography>
                    -
                </Trans>
            </Typography>

            {eventOccurrence === '1_LAB_INITIAL_INSPECTION' ||
            eventOccurrence === '2_LAB_DURING_FINALIZATION' ||
            eventOccurrence === '3_CLINIC_INITIAL_INSPECTION' ? (
                <FormControlLabel
                    value='TRANSLATION_MISSING'
                    control={<Radio />}
                    label={t('cti_option_translation_missing') as string}
                />
            ) : null}

            {eventOccurrence === '1_LAB_INITIAL_INSPECTION' ||
            eventOccurrence === '2_LAB_DURING_FINALIZATION' ||
            eventOccurrence === '3_CLINIC_INITIAL_INSPECTION' ? (
                <FormControlLabel
                    value='INFORMATION_MISLEADING'
                    control={<Radio />}
                    label={t('cti_option_information_misleading') as string}
                />
            ) : null}

            {eventOccurrence === '1_LAB_INITIAL_INSPECTION' ||
            eventOccurrence === '2_LAB_DURING_FINALIZATION' ||
            eventOccurrence === '3_CLINIC_INITIAL_INSPECTION' ||
            eventOccurrence === '4_CLINIC_DURING_PROCEDURE' ? (
                <FormControlLabel
                    value='WRONG_PART'
                    control={<Radio />}
                    label={t('cti_option_wrong_part') as string}
                />
            ) : null}

            {eventOccurrence === '1_LAB_INITIAL_INSPECTION' ||
            eventOccurrence === '2_LAB_DURING_FINALIZATION' ||
            eventOccurrence === '3_CLINIC_INITIAL_INSPECTION' ? (
                <FormControlLabel
                    value='UNABLE_TO_DISTINGUISH'
                    control={<Radio />}
                    label={t('cti_option_unable_to_distinguish') as string}
                />
            ) : null}
        </>
    )
}

export default IFUOptions
